<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'

export default {
    name: 'CanteenPickup',
    components: { ImageWrapper },
    props: {
        model: Object,
        type: String,
    },
    computed: {
        address() {
            return this.model?.address || {}
        },
        restaurants() {
            return this.model?.restaurants || {}
        },
    },
}
</script>

<template lang="pug">
router-link.card.card-hover(:to="{name: 'canteen-select', params:{location: model.id, type: type}}" tag="div")
    .card-body
        .d-flex.justify-content-between
            .content
                h4 {{address.name}}
                p.mb-0.mb-lg-3.text-73 {{address.full_address}}
                    br
                    |{{address.sub_address}}

            .align-self-center.text-26
                icon(icon="fa-solid fa-long-arrow-right")

</template>
